import React from "react";
import moment from "moment";

function DateFilter({
  startDate,
  endDate,
  setEndDate,
  setStartDate,
  selectedDuration,
}) {
  const formattedDate = (date) => {
    return moment(date).format("YYYY-MM-DD");
  };

  const formattedDateforStateForStartDate = (date) => {
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
  };
  const formattedDateforStateForEndDate = (date) => {
    if (date == moment().format("YYYY-MM-DD")) {
      return moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
    } else return moment(date).endOf("day").format("YYYY-MM-DD HH:mm:ss");
  };

  if (selectedDuration == 5) {
    return (
      <div className="d-flex">
        <div className="d-flex align-items-center content-200 w-100 gap-2 me-2">
          <input
            type="date"
            className="form-control"
            value={formattedDate(startDate)}
            max={moment().format("YYYY-MM-DD")}
            onChange={(e) => {
              setStartDate(formattedDateforStateForStartDate(e.target.value));
            }}
          />
        </div>
        <div className="d-flex align-items-center content-200 w-100 gap-2">
          <input
            type="date"
            className="form-control"
            max={moment().format("YYYY-MM-DD")}
            value={formattedDate(endDate)}
            onChange={(e) => {
              setEndDate(formattedDateforStateForEndDate(e.target.value));
            }}
          />
        </div>
      </div>
    );
  }
  return null;
}

export default DateFilter;
